module.exports = __webpack_public_path__ + "img/symbol_0.8db5fad5.png";